import React from 'react';
import { Button, Dropdown, Grid, GridColumn, GridRow } from 'semantic-ui-react';
import styled from 'styled-components';

import ActivityIndicator from '../../components/ActivityIndicator';

const TableNavigation = ({
  isBusy,
  messageAction,
  selection,
  handleDelete,
}) => {
  return (
    <Grid columns={2} verticalAlign="middle" padded="vertically">
      <GridRow stretched>
        <GridColumn>
          {isBusy ? (
            <ActivityIndicator title={messageAction || 'Loading data...'} />
          ) : (
            <Instructions>
              Select one or more Consolidated Cargos to do actions
            </Instructions>
          )}
        </GridColumn>
        <GridColumn textAlign="right">
          <div>
            <Dropdown
              text="Bulk Actions"
              as={Button}
              primary
              compact
              style={{ marginRight: 0 }}
              disabled={!selection.length}
            >
              <Dropdown.Menu>
                <Dropdown.Item
                  text="Delete"
                  onClick={handleDelete}
                  disabled={false}
                />
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </GridColumn>
      </GridRow>
    </Grid>
  );
};

const Instructions = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  letter-spacing: 0.25px;
  text-align: left;
  line-height: 20px;
`;

export default TableNavigation;
